import * as React from 'react'
import {H1} from '@frontrow/console/src/components/typography'
import {Button} from '@frontrow/console/src/components/button'
import {type ColumnDef} from '@tanstack/react-table'

import {
  type IdpOverlayStudentT,
  type IdpOverlayStudentPOST
} from '@frontrow/console/src/models/idp-overlay-student.types'
import DataTable from '@frontrow/console/src/components/common/data-table'
import CreateButton from '@frontrow/console/src/components/pages/roster-page/idp-overlay-students-page/idp-overlay-student-create-button-modal'

type Props = {
  isLoading: boolean
  overlays: Array<IdpOverlayStudentT>
  postOverlay: (data: IdpOverlayStudentPOST) => Promise<unknown>
  deleteOverlay: (id: number) => Promise<unknown>
}

export default function IdpOverlayStudents(props: Props): React.ReactElement {
  const {overlays, isLoading, postOverlay, deleteOverlay} = props

  const columns: ColumnDef<IdpOverlayStudentT, unknown>[] = [
    {
      id: 'overlay.idp',
      header: 'IdP',
      accessorFn: overlay => {
        switch (overlay.idp) {
          case 'clever':
            return 'Clever'
          case 'class-link':
            return 'ClassLink'
          default:
            return overlay.idp
        }
      }
    },
    {
      id: 'overlay.idpId',
      header: 'IdP ID',
      accessorFn: overlay => overlay.idpId
    },
    {
      id: 'overlay.type',
      header: 'Type',
      accessorFn: overlay => {
        switch (overlay.type) {
          case 'first-name':
            return 'First Name'
          case 'last-name':
            return 'Last Name'
          case 'grade':
            return 'Grade'
          default:
            return overlay.type
        }
      }
    },
    {
      id: 'overlay.value',
      header: 'Value',
      accessorFn: overlay => overlay.value
    },
    {
      id: 'action',
      header: 'Action',
      accessorFn: () => null,
      cell: ctx => (
        <Button
          style="link"
          onClick={() => {
            deleteOverlay(ctx.row.original.id)
          }}
        >
          <i className="fa fa-trash fa-lg" />
        </Button>
      ),
      enableColumnFilter: false,
      enableSorting: false
    }
  ]

  return (
    <React.Fragment>
      <H1>IdP Overlay Students</H1>
      <CreateButton postOverlay={postOverlay} />
      <DataTable
        columns={columns}
        data={overlays}
        isLoading={isLoading}
        filterable
        updateUrlOnFilter={false}
      />
    </React.Fragment>
  )
}
